/**
 * EmptyState Component
 * Premium empty state display with glassmorphism
 */

import React from 'react';
import { cn } from '../../utils';
import { Button } from './Button';
import { Plus } from 'lucide-react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center py-12 px-4',
        className
      )}
    >
      {icon && (
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary-500/20 to-accent-500/20 flex items-center justify-center mb-6 text-primary-400">
          {icon}
        </div>
      )}

      <h3 className="text-xl font-semibold text-white mb-2">
        {title}
      </h3>

      {description && (
        <p className="text-slate-400 mb-6 max-w-md">
          {description}
        </p>
      )}

      {action && (
        <Button
          variant="gradient"
          onClick={action.onClick}
          icon={<Plus className="w-4 h-4" />}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
};